import React from 'react';
import JSONPretty from 'react-json-pretty';
import { Button, Dialog, Loading, MessagePlugin, Space } from 'tdesign-react';
import doCopy from 'copy-to-clipboard';
import styled from 'styled-components';
import { isVoid } from '@/utils/common';

const getJsonStr = (json) => {
  if (typeof json === 'object') {
    json = JSON.stringify(json);
  }
  return json;
};

export default function JSONModal({ json, title, visible, handleClose, loading, theme }) {
  return (
    <Dialog
      className='json-code-dialog'
      visible={visible}
      destroyOnClose
      onClose={handleClose}
      width='80%'
      placement='center'
      header={
        <Space align='center'>
          {title}
          <Button
            size='small'
            onClick={() => {
              doCopy(getJsonStr(json));
              MessagePlugin.info('已拷贝');
            }}
          >
            复制
          </Button>
        </Space>
      }
      footer={null}
    >
      <Loading loading={isVoid(loading) ? false : loading}>
        <Root>
          <JSONPretty data={json} theme={theme || require('react-json-pretty/dist/acai')} />
        </Root>
      </Loading>
    </Dialog>
  );
}

const Root = styled.div`
  pre {
    min-height: 500px;
  }
`;
